import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { transduce } from "./core";
import { lazyTransduce } from "./iterables";
import { count, every, find, first, forEach, isEmpty, joinToString, max, min, some, sum, toArray, toAverage, toMap, toMapGroupBy, toObject, toObjectGroupBy, toSet } from "./reducers";
import { dedupe, drop, dropWhile, filter, flatMap, flatten, interpose, map, mapIndexed, partitionAll, partitionBy, remove, take, takeNth, takeWhile } from "./transducers";
export function chainFrom(collection) {
  return new TransducerChain(collection);
}
export function transducerBuilder() {
  return new TransducerChain([]);
}

var TransducerChain =
/**@__PURE__*/
function () {
  function TransducerChain(collection) {
    this.collection = collection;
    this.transducers = [];
  }

  TransducerChain.prototype.compose = function (transducer) {
    this.transducers.push(transducer);
    return this;
  };

  TransducerChain.prototype.build = function () {
    var _this = this;

    return function (x) {
      var result = x;

      for (var i = _this.transducers.length - 1; i >= 0; i--) {
        result = _this.transducers[i](result);
      }

      return result;
    };
  }; // ----- Composing transducers -----


  TransducerChain.prototype.dedupe = function () {
    return this.compose(dedupe());
  };

  TransducerChain.prototype.drop = function (n) {
    return this.compose(drop(n));
  };

  TransducerChain.prototype.dropWhile = function (pred) {
    return this.compose(dropWhile(pred));
  };

  TransducerChain.prototype.filter = function (pred) {
    return this.compose(filter(pred));
  };

  TransducerChain.prototype.flatMap = function (f) {
    return this.compose(flatMap(f));
  }; // @ts-ignore


  TransducerChain.prototype.flatten = function () {
    return this.compose(flatten());
  };

  TransducerChain.prototype.interpose = function (separator) {
    return this.compose(interpose(separator));
  };

  TransducerChain.prototype.map = function (f) {
    return this.compose(map(f));
  };

  TransducerChain.prototype.mapIndexed = function (f) {
    return this.compose(mapIndexed(f));
  };

  TransducerChain.prototype.partitionAll = function (n) {
    return this.compose(partitionAll(n));
  };

  TransducerChain.prototype.partitionBy = function (f) {
    return this.compose(partitionBy(f));
  };

  TransducerChain.prototype.remove = function (pred) {
    return this.compose(remove(pred));
  };

  TransducerChain.prototype.removeAbsent = function () {
    return this.remove(function (item) {
      return item == null;
    });
  };

  TransducerChain.prototype.take = function (n) {
    return this.compose(take(n));
  };

  TransducerChain.prototype.takeNth = function (n) {
    return this.compose(takeNth(n));
  };

  TransducerChain.prototype.takeWhile = function (pred) {
    return this.compose(takeWhile(pred));
  };

  TransducerChain.prototype.reduce = function (reducer, initialValue) {
    if (typeof reducer === "function") {
      // Type coercion because in this branch, TResult and TCompleteResult are
      // the same, but the checker doesn't know that.
      return transduce(this.collection, this.build(), reducer, initialValue);
    } else {
      return transduce(this.collection, this.build(), reducer);
    }
  }; // @ts-ignore


  TransducerChain.prototype.average = function () {
    return this.reduce(toAverage());
  };

  TransducerChain.prototype.count = function () {
    return this.reduce(count());
  };

  TransducerChain.prototype.every = function (pred) {
    return this.reduce(every(pred));
  };

  TransducerChain.prototype.find = function (pred) {
    return this.reduce(find(pred));
  };

  TransducerChain.prototype.first = function () {
    return this.reduce(first());
  };

  TransducerChain.prototype.forEach = function (f) {
    this.reduce(forEach(f));
  };

  TransducerChain.prototype.isEmpty = function () {
    return this.reduce(isEmpty());
  };

  TransducerChain.prototype.joinToString = function (separator) {
    return this.reduce(joinToString(separator));
  }; // @ts-ignore


  TransducerChain.prototype.max = function (comparator) {
    return this.reduce(max(comparator));
  }; // @ts-ignore


  TransducerChain.prototype.min = function (comparator) {
    return this.reduce(min(comparator));
  };

  TransducerChain.prototype.some = function (pred) {
    return this.reduce(some(pred));
  }; // @ts-ignore


  TransducerChain.prototype.sum = function () {
    return this.reduce(sum());
  };

  TransducerChain.prototype.toArray = function () {
    return this.reduce(toArray());
  };

  TransducerChain.prototype.toMap = function (getKey, getValue) {
    return this.reduce(toMap(getKey, getValue));
  };

  TransducerChain.prototype.toMapGroupBy = function (getKey, transformer) {
    return this.reduce(toMapGroupBy(getKey, transformer));
  };

  TransducerChain.prototype.toObject = function (getKey, getValue) {
    return this.reduce(toObject(getKey, getValue));
  };

  TransducerChain.prototype.toObjectGroupBy = function (getKey, transformer) {
    return this.reduce(toObjectGroupBy(getKey, transformer));
  };

  TransducerChain.prototype.toSet = function () {
    return this.reduce(toSet());
  };

  TransducerChain.prototype.toIterator = function () {
    return lazyTransduce(this.collection, this.build());
  };

  return TransducerChain;
}();